<template>
  <div>
    <v-card v-if="companyAttorney">
      <v-toolbar
          color="primary"
          dark
          flat
      >
        <v-toolbar-title>Доверенность</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-btn text color="primary" @click="onPrintClicked">Распечатать</v-btn>

        <template v-if="isSignAllowed">
          <template v-if="$store.getters.isCertificateLoaded">
            <v-btn text color="primary" @click="onSignClicked">Подписать</v-btn>
          </template>
          <template v-else>
            <v-btn
                color="primary"
                text
                @click="selectCertificateModal = true"
            >
              Подписать
            </v-btn>

            <v-dialog v-model="selectCertificateModal" max-width="480" :persistent="true">
              <v-card>
                <v-toolbar
                    color="primary"
                    dark
                    flat
                >
                  <v-toolbar-title>
                    Выбор ключа
                  </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <ActivateCertificate @cancel="selectCertificateModal = false"
                                       @activated="onSignClicked()"/>
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn
                      color="warning"
                      text
                      @click="selectCertificateModal = false"
                  >
                    Отменить
                  </v-btn>
                </v-card-actions>
              </v-card>

            </v-dialog>
          </template>
        </template>
      </v-card-text>

      <hr>

      <v-card-text>
        <v-row>
          <v-col>
            <h3>Организация: ИП OOO Anglesey Food</h3>
          </v-col>
          <v-col class="text-right">
            <h3>Доверенность № {{ companyAttorney.number }}</h3>
            <p class="my-2">
              Дата выдачи <b>{{ companyAttorney.start.format('DD MMMM YYYY г.') }}</b>
            </p>
            <p class="my-2">
              Доверенность действительна по <b>{{ companyAttorney.end.format('DD MMMM YYYY г.') }}</b>
            </p>
          </v-col>
        </v-row>

        <v-simple-table>
          <template v-slot:default>
            <tbody>
            <tr>
              <td colspan="2">
                Организация: ИП OOO Anglesey Food, ИНН 202099756, ОКЕД 47110, Toshkent shahri, Chilonzor
                tumani Turob to'la ko'chasi 57-uy, Besh yog'goch hududi тел: 712270550
              </td>
            </tr>
            <tr>
              <td class="text-right">Cчёт №</td>
              <td class="text-left">р/с 20208000900578902001, в банке ТОШКЕНТ Ш., ТИФ МИЛЛИЙ БАНКИНИНГ
                АКАДЕМИЯ ФИЛИАЛИ, МФО 00431
              </td>
            </tr>
            <tr>
              <td class="text-right">Доверенность выдана</td>
              <td class="text-left">{{ companyAttorney.position }} {{ companyAttorney.fullname }}</td>
            </tr>
            <tr>
              <td class="text-right">Пасспорт серия</td>
              <td class="text-left">{{ companyAttorney.passportSerial }}, № {{
                  companyAttorney.passportNumber }}
              </td>
            </tr>
            <tr>
              <td class="text-right">Кем выдан</td>
              <td class="text-left">{{ companyAttorney.passportIssuer }}</td>
            </tr>
            <tr>
              <td class="text-right">Дата выдачи</td>
              <td class="text-left">{{ companyAttorney.passportIssuedOn ?
                  companyAttorney.passportIssuedOn.format('DD MMMM YYYY г.') : null }}
              </td>
            </tr>
            <tr>
              <td class="text-right">На получение от</td>
              <td class="text-left">{{ companyAttorney.contractorName }}</td>
            </tr>
            <tr>
              <td class="text-right">материальных ценностей <br> по договору</td>
              <td class="text-left">
                {{ companyAttorney.contractNumber }}
                {{ companyAttorney.contractDate ? companyAttorney.contractDate.format('DD MMMM YYYY г.')
                  : null }}
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>

        <p class="text-center mt-5 mb-0"><b>Перечень товарно-материальных ценностей, подлежащих получению</b>
        </p>
        <v-simple-table>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-center" style="width: 100px;">Номер по порядку</th>
              <th class="text-left">Материальные ценности</th>
              <th class="text-center">Единица измерения</th>
              <th class="text-center">Количество</th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="(item, index) in companyAttorney.items" :key="item.id">
              <td class="text-center">{{ index + 1 }}</td>
              <td class="text-left">{{ item.product }}</td>
              <td class="text-center">{{ item.measurement }}</td>
              <td class="text-center">{{ item.quantity | decimal }} ({{sumWithText(item.quantity)}})</td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>

        <p class="my-5"></p>

        <v-simple-table>
          <template v-slot:default>
            <tbody>
            <tr>
              <td class="text-left">Подпись лица, получившего доверенность
                ____________________________________ удостоверяем
              </td>
            </tr>
            <tr>
              <td class="text-left">
                <b class="mr-5">Руководитель</b>
                <template v-if="companyAttorney.isSigned">
                                    <span class="font-italic">
                                        Подписан серфтикатом: <b>{{ companyAttorney.signedCertificateSerial }}</b>
                                    </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                </template>
                <template v-else>
                  ____________________________________
                </template>
                <b>Асадов А. Ш.</b>
              </td>
            </tr>
            <tr>
              <td class="text-left"><b class="mr-5">Главный бухгалтер</b>
                ____________________________________ <b>Хисматова Л. М.</b></td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>

    <v-overlay :value="loading">r
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import AttorneyService from '@/services/attorney.service'
import SignService from '@/services/sign/sign.service'
import ActivateCertificate from '@/components/main/sign/ActivateCertificate'
import EImzo from '@/plugins/eimzo'
import Moment from 'moment'
import _ from 'underscore';
import AmountTextHelper from '@/helpers/amount.text';

export default {
  name: "CompanyAttorneyPage",
  components: {
    ActivateCertificate
  },
  data() {
    return {
      companyAttorney: null,
      loading: false,
      selectCertificateModal: false
    };
  },
  computed: {
    isCompanyAttorneyReady() {
      return this.companyAttorney !== null;
    },
    isSignAllowed() {
      return this.isCompanyAttorneyReady
          && !this.companyAttorney.isSigned
          && this.companyAttorney.ownerInn === this.$store.getters.companyInn;
    },

  },
  methods: {
    sumWithText(value) {
      return AmountTextHelper.getText(value, true);
    },
    load() {
      const vm = this;

      const id = vm.$route.params.id;
      this.loading = true;
      AttorneyService.getCompanyAttorney(id)
          .then(response => {
            vm.companyAttorney = {
              id: response.data.Id,
              ownerInn: response.data.OwnerInn,
              ownerName: response.data.OwnerName,
              number: response.data.Number,
              createdOn: Moment(response.data.Number),
              start: Moment(response.data.Start),
              end: Moment(response.data.End),
              position: response.data.Position,
              fullname: response.data.Fullname,
              personInn: response.data.PersonInn,
              passportSerial: response.data.PassportSerial,
              passportNumber: response.data.PassportNumber,
              passportIssuer: response.data.PassportIssuer,
              passportIssuedOn: response.data.PassportIssuedOn ? Moment(response.data.PassportIssuedOn) : null,
              contractorInn: response.data.ContractorInn,
              contractorName: response.data.ContractorName,
              contractNumber: response.data.ContractNumber,
              contractDate: response.data.ContractDate ? Moment(response.data.ContractDate) : null,
              isSigned: response.data.IsSign,
              signedOn: response.data.SignedOn ? Moment(response.data.SignedOn) : null,
              signedCertificateSerial: response.data.SignedCertificateSerial,
              items: _.map(response.data.Items, i => {
                return {
                  id: i.Id,
                  product: i.Product,
                  measurement: i.Measurement,
                  quantity: i.Quantity
                };
              })
            };
          })
          .finally(() => {
            vm.loading = false;
          });
    },
    onPrintClicked() {
      if (this.isCompanyAttorneyReady) {
        AttorneyService.printPdf(this.companyAttorney.id);
      }
    },
    onSignClicked() {
      const vm = this;

      vm.loading = true;
      SignService.getAttorneySignProperties(vm.companyAttorney.id)
          .then(response => {
            if (response.data.HashDetail && response.data.HashDetail.FakturaHashCode) {
              EImzo.createPkcs7(response.data.HashDetail.FakturaHashCode, vm.$store.getters.certificate)
                  .then(signResult => {
                    SignService.signAttorney(vm.companyAttorney.id, {
                      fakturaPkcs7: signResult.pkcs7,
                      certificateSerial: signResult.serialNumber
                    })
                        .then(() => {
                          vm.load();
                        }, () => {
                          vm.loading = false;
                        })
                  }, () => {
                    vm.loading = false;
                  });
            } else {
              vm.loading = false;
            }
          }, () => {
            vm.loading = false;
          });
    }
  },
  "$route.params.id": function () {
    this.load();
  },
  created() {
    this.load();
  }
}
</script>

<style scoped>

</style>
